import { createSelector } from 'reselect';

const profilePhoto = (state) => state.profilesettings.profileData.profilePhoto;
const profileInfo = (state) => state.profilesettings.profileData;
export const getProfilePhoto = createSelector([profilePhoto], (data) => data);
export const getProfileInfo = createSelector([profileInfo], (data) => data);

